module.exports = __webpack_public_path__ + "img/title_2.64267ac2.png";